/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * Template API
 * Something something. <br><br>The spec is available at <a href='/swagger/api.json'>/swagger/api.json</a>.
 * OpenAPI spec version: 0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ApiAppError,
  CreateEmployeeRequest,
  CreateEmployeeResponse,
  GetEmployeeResponse,
  GetEmployeesParams,
  GetEmployeesResponse,
  UpdateEmployeeRequest,
  UpdateEmployeeResponse
} from './schemas'
import { getApi } from '../client';
import type { ErrorType, BodyType } from '../client';



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Create Employee
 */
export const createEmployee = (
    createEmployeeRequest: BodyType<CreateEmployeeRequest>,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<CreateEmployeeResponse>(
      {url: `/employee`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createEmployeeRequest, signal
    },
      options);
    }
  


export const getCreateEmployeeMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployee>>, TError,{data: BodyType<CreateEmployeeRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmployee>>, TError,{data: BodyType<CreateEmployeeRequest>}, TContext> => {
    
const mutationKey = ['createEmployee'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmployee>>, {data: BodyType<CreateEmployeeRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createEmployee(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof createEmployee>>>
    export type CreateEmployeeMutationBody = BodyType<CreateEmployeeRequest>
    export type CreateEmployeeMutationError = ErrorType<ApiAppError>

    /**
 * @summary Create Employee
 */
export const useCreateEmployee = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployee>>, TError,{data: BodyType<CreateEmployeeRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof createEmployee>>,
        TError,
        {data: BodyType<CreateEmployeeRequest>},
        TContext
      > => {

      const mutationOptions = getCreateEmployeeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete Employee
 */
export const deleteEmployee = (
    id: string,
 options?: SecondParameter<typeof getApi>,) => {
      
      
      return getApi<void>(
      {url: `/employee/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteEmployeeMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployee>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmployee>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteEmployee'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmployee>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteEmployee(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmployee>>>
    
    export type DeleteEmployeeMutationError = ErrorType<ApiAppError>

    /**
 * @summary Delete Employee
 */
export const useDeleteEmployee = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployee>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmployee>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteEmployeeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get Employee
 */
export const getEmployee = (
    id: string,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<GetEmployeeResponse>(
      {url: `/employee/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetEmployeeQueryKey = (id: string,) => {
    return [`/employee/${id}`] as const;
    }

    
export const getGetEmployeeQueryOptions = <TData = Awaited<ReturnType<typeof getEmployee>>, TError = ErrorType<ApiAppError>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployee>>, TError, TData>>, request?: SecondParameter<typeof getApi>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployee>>> = ({ signal }) => getEmployee(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployee>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeeQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployee>>>
export type GetEmployeeQueryError = ErrorType<ApiAppError>


export function useGetEmployee<TData = Awaited<ReturnType<typeof getEmployee>>, TError = ErrorType<ApiAppError>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployee>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployee>>,
          TError,
          Awaited<ReturnType<typeof getEmployee>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployee<TData = Awaited<ReturnType<typeof getEmployee>>, TError = ErrorType<ApiAppError>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployee>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployee>>,
          TError,
          Awaited<ReturnType<typeof getEmployee>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployee<TData = Awaited<ReturnType<typeof getEmployee>>, TError = ErrorType<ApiAppError>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployee>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Employee
 */

export function useGetEmployee<TData = Awaited<ReturnType<typeof getEmployee>>, TError = ErrorType<ApiAppError>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployee>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeeQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get Employee
 */
export const prefetchGetEmployee = async <TData = Awaited<ReturnType<typeof getEmployee>>, TError = ErrorType<ApiAppError>>(
 queryClient: QueryClient, id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployee>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetEmployeeQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


/**
 * @summary Update Employee
 */
export const updateEmployee = (
    id: string,
    updateEmployeeRequest: BodyType<UpdateEmployeeRequest>,
 options?: SecondParameter<typeof getApi>,) => {
      
      
      return getApi<UpdateEmployeeResponse>(
      {url: `/employee/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateEmployeeRequest
    },
      options);
    }
  


export const getUpdateEmployeeMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployee>>, TError,{id: string;data: BodyType<UpdateEmployeeRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployee>>, TError,{id: string;data: BodyType<UpdateEmployeeRequest>}, TContext> => {
    
const mutationKey = ['updateEmployee'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployee>>, {id: string;data: BodyType<UpdateEmployeeRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateEmployee(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployee>>>
    export type UpdateEmployeeMutationBody = BodyType<UpdateEmployeeRequest>
    export type UpdateEmployeeMutationError = ErrorType<ApiAppError>

    /**
 * @summary Update Employee
 */
export const useUpdateEmployee = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployee>>, TError,{id: string;data: BodyType<UpdateEmployeeRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployee>>,
        TError,
        {id: string;data: BodyType<UpdateEmployeeRequest>},
        TContext
      > => {

      const mutationOptions = getUpdateEmployeeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get Employees
 */
export const getEmployees = (
    params?: GetEmployeesParams,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<GetEmployeesResponse>(
      {url: `/employees`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetEmployeesQueryKey = (params?: GetEmployeesParams,) => {
    return [`/employees`, ...(params ? [params]: [])] as const;
    }

    
export const getGetEmployeesQueryOptions = <TData = Awaited<ReturnType<typeof getEmployees>>, TError = ErrorType<ApiAppError>>(params?: GetEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployees>>, TError, TData>>, request?: SecondParameter<typeof getApi>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployees>>> = ({ signal }) => getEmployees(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployees>>>
export type GetEmployeesQueryError = ErrorType<ApiAppError>


export function useGetEmployees<TData = Awaited<ReturnType<typeof getEmployees>>, TError = ErrorType<ApiAppError>>(
 params: undefined |  GetEmployeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployees>>,
          TError,
          Awaited<ReturnType<typeof getEmployees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployees<TData = Awaited<ReturnType<typeof getEmployees>>, TError = ErrorType<ApiAppError>>(
 params?: GetEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployees>>,
          TError,
          Awaited<ReturnType<typeof getEmployees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployees<TData = Awaited<ReturnType<typeof getEmployees>>, TError = ErrorType<ApiAppError>>(
 params?: GetEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployees>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Employees
 */

export function useGetEmployees<TData = Awaited<ReturnType<typeof getEmployees>>, TError = ErrorType<ApiAppError>>(
 params?: GetEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployees>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployeesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get Employees
 */
export const prefetchGetEmployees = async <TData = Awaited<ReturnType<typeof getEmployees>>, TError = ErrorType<ApiAppError>>(
 queryClient: QueryClient, params?: GetEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployees>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetEmployeesQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


